import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField } from '@material-ui/core';

import { EeModal } from 'components/EeModal/EeModal';

import { useCapTableReport } from './useCapTableReport';
import useStyles from './CapTableReportStyles';


export function CapTableReport(props: {fundInvestmentId: string, isOpen: boolean, onClose: () => void}) {
  const classes = useStyles();
  const logic = useCapTableReport(props.fundInvestmentId, props.isOpen, props.onClose);

  return (
    <EeModal
      width='xs'
      open={logic.isOpen}
      scroll='body'
      title='Detailed cap table report'
      submitTitle='Export'
      onClose={logic.onClose}
      onSubmit={logic.onSubmit}
    >
      <form className={classes.form}>
        <label className={classes.inputLabel}>Date</label>
        <Controller
          name='date'
          control={logic.form.control}
          render={(props) => (
            <TextField
              {...props}
              type='date'
              error={!!logic.form.errors.date}
              variant='outlined'
              margin='dense'
              fullWidth
              autoFocus
              helperText={logic.form.errors.date?.message || ' '}
              classes={{ root: classes.formControl }}
            />
          )}
        />
        <label className={classes.inputLabel}>Email</label>
        <Controller
          name='email1'
          control={logic.form.control}
          render={(props) => (
            <TextField
              {...props}
              error={!!logic.form.errors.email1}
              variant='outlined'
              margin='dense'
              fullWidth
              autoComplete='email'
              autoFocus
              helperText={logic.form.errors.email1?.message || ' '}
              classes={{ root: classes.formControl }}
            />
          )}
        />
        <label className={classes.inputLabel}>Email confirmation</label>
        <Controller
          name='email2'
          control={logic.form.control}
          render={(props) => (
            <TextField
              {...props}
              error={!!logic.form.errors.email2}
              variant='outlined'
              margin='dense'
              fullWidth
              helperText={logic.form.errors.email2?.message || ' '}
              classes={{ root: classes.formControl }}
            />
          )}
        />
      </form>
    </EeModal>
  );
}
